module.exports = __webpack_public_path__ + "static/img/seachCompany_noData.2035c7d3.png";